export const ToastState = {
  FadeIn: 'fade-in',
  Static: 'static',
  FadeOut: 'fade-out'
} as const;

export type ToastState = ValueOf<typeof ToastState>;

export const ToastActionType = {
  Add: 'Add',
  Update: 'Update',
  Clear: 'Clear'
} as const;

export type ToastActionType = ValueOf<typeof ToastActionType>;